import React, { useEffect, useState, useRef } from "react";
import { RiAdminFill } from "react-icons/ri";
import { ImPlus } from "react-icons/im";
import pages from "../index";
import { Collapse } from "reactstrap";
import {
  ScrollArea,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarImage,
  useToast,
} from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import constant from "../../constants";
import { Header } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { statuses } from "../../constants";
import { CSVLink, CSVDownload } from "react-csv";
import { thaiDate, role } from "../../util";
import { DatePicker, Spin } from "antd";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportShop = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs } = Context();
  const [orders, setOrders] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);

  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(false);
  const [filter, setFilter] = useState(false);
  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading(true);

    const allUserData = [];
    let keepGoing = true;
    let currentIndex = 0;
    let startAtId = "";
    let limit = 5000;

    while (keepGoing) {
      console.log(`calling index ${currentIndex}-${currentIndex + limit}`);
      const data = await callApi(
        "products-getAllTransaction",
        {
          roundDate: selectedRoundDate,
          queries:
            filter === "admin"
              ? [
                  ["createdByAdmin", true],
                  ["roundDate", selectedRoundDate],
                ]
              : [["roundDate", selectedRoundDate]],
          limit: 50000,
          orderBy: ["createdAt", "desc"],
        },
        { notShowLoading: true },
      );

      if (data.length < limit || !data.length || !data) {
        console.log("stop");
        keepGoing = false;
        setLoading(false);
      } else {
        console.log(`fetching size: ${data.length}`);
        console.log("id", data[data.length - 1].id);
        startAtId = data[data.length - 1].id;
      }

      allUserData.push(...data);
      console.log(`allUserData size: ${allUserData.length}`);
      currentIndex += limit;
    }

    const summaryData = allUserData.reduce((acc, order) => {
      const { createdByAdmin, createdBy, status, reservedBy } = order;
      if (createdByAdmin) {
        if (acc[createdBy?.userId || reservedBy]) {
          acc[createdBy?.userId || reservedBy][status] += 1;
        } else {
          acc[createdBy?.userId || reservedBy] = {
            createdBy: `${createdBy?.firstName} ${createdBy?.lastName} #${
              createdBy?.userId || reservedBy
            }`,
            approved: status === "approved" ? 1 : 0,
            canceled: status === "canceled" ? 1 : 0,
          };
        }
      }

      return acc;
    }, {});
    setLoading(false);

    setSummary(Object.values(summaryData));

    setOrders(allUserData.sort((a, b) => b.createdAt - a.createdAt));
  };

  const handleDownload = async () => {
    const csvBody = [
      [
        `${
          filter === "admin"
            ? "รายงานคำสั่งซื้อร้านค้า_โดยแอดมิน"
            : "รายงานคำสั่งซื้อร้านค้า"
        } งวด ${selectedRoundDate} `,
      ],
      [],
    ];
    csvBody.push([]);
    csvBody.push([`สรุป`]);
    csvBody.push([`ผู้สร้างคำสั่งซื้อ`, `รวม`, `อนุมัติ`, `ยกเลิก`]);
    csvBody.push(
      ...summary.map((e) => [
        e.createdBy,
        e.approved + e.canceled,
        e.approved,
        e.canceled,
      ]),
    );
    csvBody.push([]);
    csvBody.push([
      "ลำดับ",
      "วัน-เวลา",

      "รหัสคำสั่งซื้อ",
      "ที่อยู่ผู้รับ",
      "สินค้า",
      "ราคา",
      "ใช้คะแนน",
      "ผู้สร้าง",
      "สถานะ",
    ]);
    orders.forEach((order, index) =>
      csvBody.push([
        index + 1,
        new Date(order.createdAt).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),
        order.shortId,
        order.receiver?.address,
        `${order.product?.map((p) => `${p.name}, `)}`,
        order.totalPrice || 0,
        order.isPoint ? "Y" : "N",
        order.createdByAdmin
          ? order.createdBy?.firstName +
            " " +
            order.createdBy?.lastName +
            ` #${order.userId}`
          : "-",
        order.status,
      ]),
    );

    setCsvData(csvBody);
    setCsvFileName(
      `${
        filter === "admin"
          ? "รายงานคำสั่งซื้อร้านค้า_โดยแอดมิน"
          : "รายงานคำสั่งซื้อร้านค้า"
      }_${selectedRoundDate}.csv`,
    );
  };

  return (
    <div className="h-fit w-full min-w-[1024px] max-w-[1600px] mx-auto">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานคำสั่งซื้อร้านค้า"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">ค้นหาคำสั่งซื้อสินค้า</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="gap-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="gap-2 ">
            <p className="font-medium text-xs">ฟิลเตอร์</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value={"all"}>ทั้งหมด</option>
                <option value={"admin"}>สร้างโดยแอดมิน</option>
              </select>
            </div>
          </div>

          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            ค้นหา
          </button>
          <button
            disabled={!orders.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
            ดาวโหลด
          </button>
        </div>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-96">
          <Spinner className="w-3 h-3" />
        </div>
      ) : (
        <div>
          {/* {summary && (
            <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
              <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
                <p className="font-semibold ">สรุป</p>{" "}
              </div>

              <Table>
                <TableHeader className={`bg-[#f2f3f5]`}>
                  <TableRow>
                    <TableHead className="">ผู้สร้างคำสั่งซื้อ</TableHead>
                    <TableHead className="text-right">รวม</TableHead>
                    <TableHead className="text-right">อนุมัติ</TableHead>
                    <TableHead className="text-right">ยกเลิก</TableHead>
                  </TableRow>
                </TableHeader>

                <TableBody className={``}>
                  {orders.length > 0 ? (
                    summary.map((order, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className={`font-medium`}>
                            {order.createdBy}
                          </TableCell>
                          <TableCell className="font-medium text-right tracking-widest font-mono">
                            {order.approved + order.canceled}
                          </TableCell>
                          <TableCell className="text-right">
                            {order.approved}
                          </TableCell>
                          <TableCell className="text-right font-medium">
                            {order.canceled}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableCell className="" colSpan="6">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </div>
          )} */}
          {orders && (
            <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
              <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
                <p className="font-semibold ">คำสั่งซื้อทั้งหมด</p>{" "}
                <p className="text-xs font-semibold text-[#969797]">
                  {orders.length} คำสั่งซื้อ
                </p>
              </div>

              <Table>
                <TableHeader className={`bg-[#f2f3f5]`}>
                  <TableRow>
                    <TableHead className="">วันที่-เวลา</TableHead>
                    <TableHead className="text-center">
                      รหัสคำสั่งซื้อ
                    </TableHead>
                    <TableHead className="">ที่อยู่ผู้รับ</TableHead>
                    <TableHead className="">สินค้า</TableHead>
                    <TableHead className="">ราคา</TableHead>
                    <TableHead className="">ใช้คะแนน</TableHead>
                    <TableHead>ผู้สร้าง</TableHead>
                    <TableHead className="text-right">สถานะ</TableHead>
                    {/* <TableHead>ผู้ยกเลิก</TableHead> */}
                  </TableRow>
                </TableHeader>

                <TableBody className={``}>
                  {orders.length > 0 ? (
                    orders.map((order) => {
                      return (
                        <TableRow key={order.shortId}>
                          <TableCell className={`font-medium`}>
                            {new Date(order.createdAt).toLocaleDateString(
                              "th-TH",
                              {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                              },
                            )}{" "}
                            น.
                          </TableCell>
                          <TableCell className="font-medium text-center tracking-widest font-mono">
                            {order.shortId}
                          </TableCell>
                          <TableCell className="font-medium">
                            {order.receiver?.address}
                          </TableCell>

                          <TableCell className="">
                            {order.product.map((prod) => (
                              <p className={``}>{prod.name}</p>
                            ))}
                          </TableCell>
                          <TableCell className="font-medium ">
                            {`${order.totalPrice}`.toLocaleString() || 0}
                          </TableCell>
                          <TableCell
                            className={`${order.isPoint ? "text-green" : "text-failed"} font-medium `}
                          >
                            {order.isPoint ? "Y" : "N"}
                          </TableCell>
                          <TableCell className="font-medium">
                            {order.createdByAdmin
                              ? order.createdBy?.firstName +
                                " " +
                                order.createdBy?.lastName +
                                ` #${order.createdBy?.userId}`
                              : "-"}
                          </TableCell>
                          <TableCell className="font-medium text-right">
                            {constant.statusesTranslate[order.status]}
                          </TableCell>
                          {/* <TableCell>{order.cancelerName}</TableCell> */}
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableCell className="" colSpan="6">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
